
const Constants = Object.freeze({
  API_URL: 'https://gamestoolkitbackend.azurewebsites.net/assets',
  API_DEV_URL: 'http://localhost:3001/assets',
  DISQUS_SHORTNAME: 'gamestoolkit',
  ACTIONS: {
    FETCHING_ASSETS: 'FETCHING_ASSETS',
    SET_CURRENT_ASSET: 'SET_CURRENT_ASSET', 
    RECEIVING_ASSETS: 'RECEIVING_ASSETS'
  }
})

export default Constants